export default __webpack_public_path__ + "static/media/no-ti-m.c8bf1f1d.png";